import { Toaster as SonnerToaster } from "sonner";

export const Toaster = () => {
  return (
    <SonnerToaster
      theme="light"
      position="bottom-right"
      offset="24px"
      mobileOffset={{ bottom: "96px", top: "64px" }}
      toastOptions={{
        className: "group",
        classNames: {
          toast:
            "group toast font-sans flex items-center justify-between overflow-hidden rounded-xl border border-border bg-surface p-4 text-text shadow-[0_8px_30px_rgb(0,0,0,0.08)] backdrop-blur-xl transition-all",
          title: "text-sm font-bold tracking-tight text-text",
          description: "text-sm font-medium text-text-muted mt-1",
          actionButton:
            "inline-flex h-8 shrink-0 items-center justify-center rounded-md border border-border bg-transparent px-3 text-sm font-medium transition-colors hover:bg-canvas-muted focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50",
          cancelButton:
            "inline-flex h-8 shrink-0 items-center justify-center rounded-md border border-border bg-transparent px-3 text-sm font-medium transition-colors hover:bg-canvas-muted focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50",
          success: "border-emerald-500/20 bg-emerald-50/50  text-emerald-600 ",
          error: "border-red-500/20 bg-red-50/50  text-red-600 ",
          info: "border-blue-500/20 bg-blue-50/50  text-blue-600 ",
          warning: "border-orange-500/20 bg-orange-50/50  text-orange-600 ",
        },
      }}
    />
  );
};
